module.exports = __webpack_public_path__ + "res/img_reward_t.f22e614f25b4b85d73cc02c14742877d.png";